export enum DeleteOption {

    PRESERVE_METADATA = 'preserveMetadata', //  Moves basecall and associated data files to reduce data storage
                                            // but keeps record of a run
    RUN_COMPLETE = 'runComplete', // Moves any record of a run and associated data files but still keeps FASTQ and analysis files
    ASSOC_APPSESSIONS = 'assocAppSession', // Removes everything associated with a run including FASTQ, analyses, and basecall files,
    ALL_FILES = "dataset_All" // Removes all files (moves  everything associated with a dataset including record of it).
}
